// Waveshaper second-phase target selection: minions at a cell to tap +
// stamp with skip-next-untap. Pure. No React, no Three.js.
//
// ── Codex (Waveshaper, Submerge) ──
//   "Tap minions without submerge there. They don't untap the next
//    time they would."
//
// Submerge units (printed keyword OR aura-granted status OR manual
// status) are immune. Avatars and Sites are not "minions" and are
// excluded; Automatons ARE (artifacts that are minions per codex).

import { countsAsMinion } from '../../../core/typeline';
import { hasKeyword } from '../../../core/keywordQuery';

// Canonical keyword check: respects suppression AND silence (a silenced
// minion loses Submerge, so Waveshaper can tap it). Printed / aura /
// manual sources all flow through hasKeyword.
export function hasSubmergeKeyword(card) {
  return hasKeyword(card, 'submerge');
}

/**
 * Find every Minion at the given cell that lacks the Submerge keyword.
 * Returns the live cardInstance + mesh tuples so the orchestrator can
 * tap them via the unified _applyTap path.
 */
export function minionsToTapAtCell(meshes, cellAt, col, row) {
  const out = [];
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card || !countsAsMinion(card)) continue;
    const cell = cellAt(mesh.position.x, mesh.position.z);
    if (!cell || cell.col !== col || cell.row !== row) continue;
    if (hasSubmergeKeyword(card)) continue;
    out.push({ card, mesh });
  }
  return out;
}

/**
 * Mark a card so its NEXT untap is skipped. Honored by tap.js's
 * shouldSkipUntap predicate; consumed once and cleared.
 */
export function markSkipNextUntap(card) {
  if (!card) return;
  card._skipNextUntap = true;
}

/**
 * Consume the skip-next-untap flag. Returns true if the untap should
 * be SKIPPED this time (and clears the flag). Returns false to proceed
 * with the normal untap.
 */
export function consumeSkipNextUntap(card) {
  if (!card?._skipNextUntap) return false;
  card._skipNextUntap = false;
  return true;
}
